import { combineReducers } from "redux";

function WristbandsReducer() {
  const wristbandsInitialState = {
    error: null,
    loading: false,
    wristbands: null,
    rebootError: null,
    rebootLoading: false,
    rebootWristband: null,
  };

  const wristbands = (state = wristbandsInitialState, action) => {
    const { type, payload } = action;

    switch (type) {
      case "GET_WRISTBANDS_INIT":
        return {
          ...state,
          loading: true,
          error: null,
          wristbands: null,
        };
      case "GET_WRISTBANDS_SUCCESS":
        return {
          ...state,
          loading: false,
          error: null,
          wristbands: payload,
        };
      case "GET_WRISTBANDS_ERROR":
        return {
          ...state,
          loading: false,
          error: payload,
          wristbands: null,
        };
      case "REBOOT_WRISTBANDS_INIT":
        return {
          ...state,
          rebootLoading: true,
          rebootError: null,
          rebootWristband: null,
        };
      case "REBOOT_WRISTBANDS_SUCCESS":
        return {
          ...state,
          rebootLoading: false,
          rebootError: null,
          rebootWristband: payload,
        };
      case "REBOOT_WRISTBANDS_ERROR":
        return {
          ...state,
          rebootLoading: false,
          rebootError: payload,
          rebootWristband: null,
        };
      default:
        return state;
    }
  };

  return combineReducers({
    wristbands,
  });
}

export default WristbandsReducer();
